<div class="color-picker-wrapper">
  <div class="label">
    {{ label }}
  </div>
  <div class="color-btn" [style]="currentColor" [andorContextMenuTriggerFor]="menu"></div>
</div>

<andor-context-menu #menu mode="transparent" yPosition="below">
  <div (click)="$event.stopPropagation()">
    <color-chrome
      [color]="state"
      [disableAlpha]="true"
      (onChange)="onColorChange($event)"></color-chrome>
  </div>
</andor-context-menu>
